"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabeledRadio = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helperFunctions = require("../../../styles/helperFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledLabeledRadio = _styledComponents.default.label.withConfig({
  displayName: "LabeledRadiostyles__StyledLabeledRadio",
  componentId: "sc-1d996qf-0"
})(["display:flex;position:relative;cursor:pointer;user-select:none;margin:", ";.c-labeled-radio-label{padding:0 ", ";}"], function (props) {
  return "".concat((0, _helperFunctions.joinDimensions)('*', props.theme.standardPadding, '.5'), " 0");
}, function (props) {
  return props.theme.standardPadding;
});

exports.StyledLabeledRadio = StyledLabeledRadio;